import { useEffect, useState } from 'react';
import { DeliveryRouteInbox } from 'utils/chat/DeliveryRouteInbox';

// Mantiene suscrito el inbox de la ruta mientras la página esté montada (no solo con el panel
// del chat abierto) y devuelve { [pre_package_id]: { badge, ... } }, o null mientras el
// servidor no ha reportado o si no hay ruta.
export default function useRouteChatInbox(deliveryRouteId) {
  const [inbox, setInbox] = useState(null);

  useEffect(() => {
    if (!deliveryRouteId) {
      setInbox(null);
      return undefined;
    }

    const routeInbox = new DeliveryRouteInbox({ deliveryRouteId });
    routeInbox.subscribe(setInbox);

    return () => routeInbox.disconnect();
  }, [deliveryRouteId]);

  return inbox;
}
